var render = function render(){var _vm=this,_c=_vm._self._c;return _c('environment-template',{attrs:{"dryness-caused-by-climate":_vm.drynessCausedByClimate,"title":_vm.questionTitle,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }